module.exports = __webpack_public_path__ + "static/media/pincil-profile.08febe41.png";